import ReactGA from 'react-ga';

export default (isDevelopment) => {
  if (!isDevelopment) {
		ReactGA.initialize('UA-140696228-1');
		ReactGA.pageview(window.location.pathname + window.location.search);
  }
};

export const trackEvent = (category, action, label) => {
  const isDev = process.env.REACT_APP_NODE_ENV === 'development' ||
    process.env.REACT_APP_NODE_ENV === 'staging';
  
  if (!isDev) {
    window.ga('send', 'event', category, action, label);
  }
}